import React from 'react'
import { Card, CardContent, CardHeader } from '@/shared/ui'
import { Bell, Monitor, Smartphone } from 'lucide-react'
import { getPlatformInfo } from '@/modules/pwa/utils/platform'

export default function PushTipsCard() {
  const platform = React.useMemo(() => getPlatformInfo(), [])

  const tips: Array<{ icon: React.ReactNode; text: string }> = []
  tips.push({
    icon: <Bell className="h-4 w-4" />,
    text: 'Permita notificacoes no navegador quando solicitado.',
  })
  if (platform.isIos) {
    tips.push({
      icon: <Smartphone className="h-4 w-4" />,
      text: 'No iOS, push funciona apenas no app instalado (Adicionar a Tela de Inicio).',
    })
  } else {
    tips.push({
      icon: <Monitor className="h-4 w-4" />,
      text: 'No desktop, libere notificacoes no sistema operacional (Windows ou macOS).',
    })
  }

  return (
    <Card>
      <CardHeader className="text-sm font-medium">Dicas</CardHeader>
      <CardContent className="space-y-2">
        {tips.map((tip, idx) => (
          <div key={idx} className="flex items-start gap-2 text-sm text-foreground/80">
            <span className="mt-0.5 text-foreground/70">{tip.icon}</span>
            <span>{tip.text}</span>
          </div>
        ))}
      </CardContent>
    </Card>
  )
}
